module.exports = {
  "kbBetaOptIn": {
    "name": "KB Beta Opt In",
    "class": "interaction",
    "properties": {
      "screen": [
        "app"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "kbBetaOptOut": {
    "name": "KB Beta Opt Out",
    "class": "interaction",
    "properties": {
      "screen": [
        "app"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "onboardingStepView": {
    "name": "Onboarding Step View",
    "class": "view",
    "properties": {
      "screen": [
        "app",
        "embedded"
      ],
      "subscreen": [
        "knowledge-base-setup",
        "template-select",
        "select-categories",
        "finish",
        "create-success",
        "create-error"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "knowledgeBaseCreated": {
    "name": "Knowledge Base Created",
    "class": "interaction",
    "properties": {
      "screen": [
        "app",
        "embedded"
      ],
      "knowledgeBaseCount": {
        "type": "number"
      },
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "articles-insights",
        "manage-articles",
        "create-article",
        "article-post-publish",
        "categorize",
        "draft",
        "template-editor"
      ],
      "subscreen": {
        "type": [
          "write",
          "categorize"
        ],
        "isOptional": true
      },
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "manageArticleInteraction": {
    "name": "Manage Articles Interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "manage-articles",
        "categorize",
        "article-post-publish"
      ],
      "action": [
        "archive-article-click",
        "edit-article-click",
        "view-article-click",
        "create-article-click",
        "delete-article-click",
        "clone-article-click",
        "details-article-click",
        "unpublish-article-click",
        "unarchive-article-click",
        "connect-to-primary-article-click",
        "create-multi-lang-var-click",
        "detach-from-multi-language-group-click",
        "setup-multi-language-click",
        "view-knowledge-base",
        "change-visibility-click-single",
        "change-visibility-click-bulk",
        "change-visibility-save-single",
        "change-visibility-save-bulk",
        "change-visibility-click-bulk",
        "customize-template-click",
        "configure-header-click",
        "configure-footer-click",
        "change-view-click",
        "archive-article-bulk",
        "delete-article-bulk",
        "export-articles",
        "submit-export-articles",
        "configure-categories-click",
        "import-articles"
      ],
      "visibility": {
        "type": [
          "public",
          "lists"
        ],
        "isOptional": true
      },
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "filteredArticles": {
    "name": "Filtered Articles Interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "manage-articles"
      ],
      "filteredBy": [
        "all",
        "draft",
        "archived",
        "published",
        "categories",
        "authors",
        "visibility",
        "language"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "searchForArticles": {
    "name": "Search Articles",
    "class": "interaction",
    "properties": {
      "screen": [
        "manage-articles"
      ],
      "searchPhase": "string",
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "articleRemovalPublished": {
    "name": "Article Removal Published",
    "class": "usage",
    "properties": {
      "screen": [
        "manage-articles",
        "article-post-publish",
        "categorize"
      ],
      "action": [
        "archived",
        "deleted",
        "unpublished"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "articleRemovalDraft": {
    "name": "Article Removal Draft",
    "class": "interaction",
    "properties": {
      "screen": [
        "manage-articles",
        "article-post-publish",
        "categorize"
      ],
      "action": [
        "archived",
        "deleted",
        "unarchived"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "postPublishInteraction": {
    "name": "Post Publish Interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "article-post-publish"
      ],
      "action": [
        "archive-article-click",
        "edit-article-click",
        "view-article-click",
        "unpublish-article-click",
        "unarchive-article-click",
        "delete-article-click",
        "change-visibility-click-single",
        "post-publish-scroll",
        "clone-article-click"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "publishedOrUpdatedArticle": {
    "name": "Published Updated Article",
    "class": "usage",
    "properties": {
      "visibility": {
        "type": "string",
        "isOptional": true
      },
      "screen": [
        "create-article"
      ],
      "subscreen": [
        "write",
        "categorize"
      ],
      "action": [
        "published",
        "updated"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "createArticleInteraction": {
    "name": "Create Article Interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "create-article",
        "categorize"
      ],
      "subscreen": {
        "type": [
          "categorize",
          "write"
        ],
        "isOptional": true
      },
      "action": [
        "preview",
        "back-to-knowledge",
        "selected-category",
        "selected-subcategory",
        "changed-url",
        "add-new-category-click",
        "add-new-subcategory-click",
        "publish-article-click",
        "update-article-click",
        "add-search-tag",
        "remove-search-tag",
        "create-multi-lang-var-click",
        "create-multi-lang-var-save",
        "create-multi-lang-var-cancel",
        "changed-head-html",
        "changed-page-title",
        "changed-meta-description"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "updatedCategorization": {
    "name": "Update Categorization",
    "class": "usage",
    "properties": {
      "screen": [
        "create-article",
        "categorize"
      ],
      "subscreen": {
        "type": [
          "categorize"
        ],
        "isOptional": true
      },
      "action": [
        "created-category",
        "created-subcategory",
        "edited-category",
        "edited-subcategory",
        "deleted-category",
        "publish-category-changes",
        "discard-category-changes",
        "publish-subcategory-changes",
        "discard-subcategory-changes"
      ],
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "updatedCategorizationInteraction": {
    "name": "Update Categorization",
    "class": "interaction",
    "properties": {
      "screen": [
        "categorize"
      ],
      "action": [
        "edit-category-click",
        "edit-category-icon-click",
        "edit-subcategory-click"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "reorderedInteraction": {
    "name": "Reordered Knowledge Base",
    "class": "usage",
    "properties": {
      "screen": [
        "categorize"
      ],
      "action": [
        "moved-article",
        "moved-subcategory",
        "moved-category"
      ],
      "movedTo": {
        "type": [
          "article",
          "article-on-home-page",
          "category",
          "subcategory",
          "placeholder"
        ],
        "isOptional": true
      },
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "confirmCategorizationInteraction": {
    "name": "Clicked Update button and confirmed or rejected",
    "class": "interaction",
    "properties": {
      "screen": [
        "categorize"
      ],
      "action": [
        "update-click",
        "confirm-update",
        "cancel-update"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "importInteraction": {
    "name": "Import",
    "class": "interaction",
    "properties": {
      "screen": [
        "articles-insights"
      ],
      "action": [
        "button-click"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "templateEditorInteraction": {
    "name": "Template editor Interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "template-editor"
      ],
      "action": [
        "exit-click",
        "homepage-area-click-nav",
        "homepage-area-click-header",
        "homepage-area-click-header-message",
        "homepage-area-click-categories",
        "homepage-area-click-single-category",
        "sidebar-click-tab",
        "sidebar-click-nav",
        "sidebar-click-footer",
        "sidebar-click-homepage",
        "sidebar-click-header",
        "sidebar-click-categories",
        "delete-company-logo",
        "delete-footer-company-logo",
        "add-company-logo",
        "add-footer-company-logo",
        "footer-add-social-network",
        "footer-remove-social-network",
        "header-add-header-image",
        "header-remove-header-image",
        "header-add-background-pattern",
        "categories-select-icons",
        "categories-select-images",
        "categories-turn-off-category",
        "categories-turn-on-category",
        "categories-category-click",
        "category-remove-icon",
        "category-add-icon",
        "category-remove-image",
        "category-add-image",
        "preview-click",
        "breadcrumb-click",
        "change-view-click",
        "style-change-template-click",
        "template-choose-content-rich",
        "template-choose-tiles",
        "template-choose-minimal",
        "template-choose-cards",
        "template-choose-classic",
        "template-preview-content-rich",
        "template-preview-tiles",
        "template-preview-minimal",
        "template-preview-cards",
        "template-preview-classic",
        "support-form-enabled",
        "support-form-disabled"
      ],
      "tab": {
        "type": [
          "content",
          "styles"
        ],
        "isOptional": true
      },
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "templateEditorUpdate": {
    "name": "Template Editor Update",
    "class": "usage",
    "properties": {
      "screen": [
        "template-editor"
      ],
      "action": [
        "update"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "kbInsightsInteraction": {
    "name": "Insights Interaction",
    "class": "usage",
    "properties": {
      "screen": [
        "articles-insights"
      ],
      "action": [
        "kb-insights-scroll",
        "time-range-change",
        "article-health-sort",
        "article-health-pagination",
        "search-no-results-sort",
        "most-searched-terms-pagination",
        "search-no-results-pagination",
        "tag-articles-search-no-results",
        "tag-articles-search-no-results-header",
        "tag-articles-most-searched-terms",
        "tag-articles-most-searched-terms-header"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "kbReviewInsightsPage": {
    "name": "Review Insights Page",
    "class": "usage",
    "properties": {
      "screen": [
        "articles-insights"
      ],
      "action": [
        "greater-than-10-seconds",
        "greater-than-30-seconds",
        "greater-than-60-seconds"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "kbReviewArticlePerformance": {
    "name": "Review Article Performance",
    "class": "usage",
    "properties": {
      "screen": [
        "article-post-publish"
      ],
      "action": [
        "greater-than-10-seconds",
        "greater-than-30-seconds",
        "greater-than-60-seconds"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "tagArticlesInteraction": {
    "name": "Tag Articles Interaction",
    "class": "interaction",
    "properties": {
      "screen": [
        "articles-insights"
      ],
      "action": [
        "add-articles-click",
        "category-click",
        "article-checkbox-click",
        "done-click",
        "article-search",
        "remove-tagged-article",
        "close-click",
        "cancel-button-click"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "publishTags": {
    "name": "Publish Tags",
    "class": "usage",
    "properties": {
      "screen": [
        "articles-insights"
      ],
      "action": [
        "apply-tags"
      ],
      "isLegacyKnowledgeBase": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "knowledge-product"
  },
  "inlineEditInteraction": {
    "name": "inline edit interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "text-selected",
          "menu-open",
          "menu-selection",
          "tiny-mce-toolbar-menu-selection",
          "tone-selection",
          "click-generate",
          "click-try-again",
          "preview-window-rewrite",
          "insert-content",
          "preview-window-close",
          "preview-window-previous",
          "preview-window-next",
          "click-settings-link"
        ]
      },
      "actionType": {
        "type": [
          "slash-command",
          "selection-command"
        ]
      },
      "selected": {
        "isOptional": true,
        "type": "string"
      },
      "choice": {
        "isOptional": true,
        "type": [
          "friendly",
          "professional",
          "witty",
          "heartfelt",
          "educational"
        ]
      },
      "command": {
        "type": "string",
        "isOptional": true
      },
      "text": {
        "type": "string",
        "isOptional": true
      },
      "result": {
        "type": "string",
        "isOptional": true
      },
      "usageDescription": {
        "type": "string",
        "isOptional": true
      },
      "inline": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      },
      "regenerateClickCount": {
        "type": "number",
        "isOptional": true
      },
      "usingBrandVoice": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "content-assistance-lib"
  },
  "contentGenerationModalInteraction": {
    "name": "content generation modal interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "open-modal",
          "close-modal",
          "click-generate",
          "click-generate-more",
          "click-trigger-button",
          "fetch-results",
          "choose-result",
          "video-started",
          "video-completed",
          "turn-on-content-assistant",
          "click-maybe-later",
          "click-settings-link",
          "click-go-back"
        ]
      },
      "usageDescription": {
        "type": "string"
      },
      "text": {
        "type": "string",
        "isOptional": true
      },
      "approximateTokenCount": {
        "type": "number",
        "isOptional": true
      },
      "results": {
        "type": "array",
        "isOptional": true
      },
      "completionTokens": {
        "type": "number",
        "isOptional": true
      },
      "promptTokens": {
        "type": "number",
        "isOptional": true
      },
      "result": {
        "type": "string",
        "isOptional": true
      },
      "videoId": {
        "type": "number",
        "isOptional": true
      },
      "command": {
        "type": "string",
        "isOptional": true
      },
      "choice": {
        "isOptional": true,
        "type": "string"
      },
      "regenerateClickCount": {
        "type": "number",
        "isOptional": true
      }
    },
    "namespace": "content-assistance-lib"
  },
  "blogQuickCreateModalOpened": {
    "name": "blog quick create modal action",
    "class": "interaction",
    "namespace": "content-components"
  },
  "blogQuickCreateModalClickedCreate": {
    "name": "blog quick create modal action",
    "class": "interaction",
    "namespace": "content-components"
  },
  "audienceAccessInteraction": {
    "name": "audience access interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "click-radio-all",
          "click-radio-password",
          "click-radio-sso",
          "click-radio-specificContacts",
          "click-radio-ssoWithSpecificContacts",
          "show-password-help",
          "show-sso-help",
          "show-specificContacts-help",
          "show-ssoWithSpecificContacts-help",
          "change-lists",
          "click-kb-article",
          "show-sso-disabled-tooltip",
          "show-registration-disabled-tooltip"
        ]
      }
    },
    "namespace": "content-components"
  },
  "partnerMatchingAppInteraction": {
    "name": "partner matching app interaction",
    "namespace": "partner-matching-app",
    "class": "interaction",
    "properties": {
      "action": {
        "type": "string"
      },
      "app": {
        "type": "string"
      }
    }
  },
  "colorImportInteraction": {
    "name": "color import modal interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "submit-url",
          "website-colors-retrieved",
          "toggle-color-selection",
          "import-colors"
        ]
      }
    },
    "namespace": "content-components"
  },
  "setupCustomDomainModalInteraction": {
    "name": "setup custom domain modal interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "view",
          "clicked-add-custom-domain-button"
        ]
      },
      "screen": [
        "detail"
      ]
    },
    "namespace": "content-components"
  },
  "ContentComponentsInteraction": {
    "name": "ContentComponents interaction",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "custom-fonts-upload-modal-opened",
          "custom-fonts-upload-modal-closed",
          "custom-fonts-create-font",
          "custom-fonts-edit-font",
          "custom-fonts-delete-font"
        ]
      }
    },
    "namespace": "content-components"
  },
  "contentCreateAutoTranslationActionUsage": {
    "name": "content-create-autotranslation-action",
    "class": "usage",
    "properties": {
      "action": [
        "create-multi-language-variation",
        "direct-translate"
      ],
      "status": [
        "success",
        "fail"
      ],
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string"
      },
      "pageType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "content-components"
  },
  "contentCreateAutoTranslationActionActivation": {
    "name": "content-create-autotranslation-action",
    "class": "activation",
    "properties": {
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string"
      },
      "pageType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "content-components"
  },
  "contentCreateAutoTranslationActionInteraction": {
    "name": "content-create-autotranslation-action",
    "class": "interaction",
    "properties": {
      "action": [
        "clicked-submit-create-multi-language-variation",
        "clicked-ai-translate-toggle"
      ],
      "screen": {
        "type": "string"
      },
      "subscreen": {
        "type": "string"
      },
      "pageType": {
        "type": "string",
        "isOptional": true
      },
      "isAutoTranslateEnabled": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "content-components"
  },
  "componentInteraction": {
    "name": "component interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "app": "string",
      "id": {
        "type": "string",
        "isOptional": true
      },
      "suggestionCategory": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "editor-platform"
  },
  "tinymceEdit": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceCommand": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "value": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymcePaste": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "type": [
        "file",
        "html",
        "plaintext",
        "unknown"
      ],
      "pasteSource": {
        "type": "string",
        "isOptional": true
      },
      "hasImages": {
        "type": "boolean",
        "isOptional": true
      },
      "overwriteExisting": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEvent": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditSourceCode": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceChangeColor": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceColorPopoverMode": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "mode": {
        "type": "string"
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceChangeColorPopover": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "mode": {
        "type": "string",
        "isOptional": true
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "format": {
        "type": "string",
        "isOptional": true
      },
      "had-existing-color": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceCta": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "context": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceFormatting": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "isCustomFont": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceLink": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "nofollow": {
        "type": "boolean",
        "isOptional": true
      },
      "sponsored": {
        "type": "boolean",
        "isOptional": true
      },
      "ugc": {
        "type": "boolean",
        "isOptional": true
      },
      "externalLink": {
        "type": "boolean",
        "isOptional": true
      },
      "isImage": {
        "type": "boolean",
        "isOptional": true
      },
      "isIcon": {
        "type": "boolean",
        "isOptional": true
      },
      "linkType": {
        "type": "string",
        "isOptional": true
      },
      "isValidLink": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceImage": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "method": {
        "type": "string",
        "isOptional": true
      },
      "replacedImgSrc": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceContentGeneration": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditImage": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "imgSrc": {
        "type": "string",
        "isOptional": true
      },
      "fileSource": {
        "type": [
          "AI_GENERATED",
          "CANVA",
          "SHUTTERSTOCK"
        ],
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEmbed": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertEmbed": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "service": {
        "type": "string",
        "isOptional": true
      },
      "tab": [
        "general",
        "embed",
        "paste"
      ],
      "hasDimensions": {
        "type": "boolean",
        "isOptional": true
      },
      "useIframeEmbeds": {
        "type": "boolean",
        "isOptional": true
      },
      "hasScripts": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditEmbed": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymcePersonalize": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "category": "string",
      "fqn": "string",
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertPersonalizationToken": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "tokenName": "string",
      "tokenCategory": {
        "type": "string",
        "isOptional": true
      },
      "isHubspotDefined": {
        "type": "boolean",
        "isOptional": true
      },
      "defaultValueType": [
        "global",
        "local",
        "empty"
      ],
      "fieldType": {
        "type": "string"
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditPersonalizationToken": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "tokenName": "string",
      "tokenCategory": {
        "type": "string",
        "isOptional": true
      },
      "isHubspotDefined": {
        "type": "boolean",
        "isOptional": true
      },
      "defaultValueType": [
        "global",
        "local",
        "empty"
      ],
      "fieldType": {
        "type": "string"
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertRssToken": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "tokenName": "string",
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceVideo": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "type": "string",
      "method": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertVideo": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "type": "string",
      "replaced": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditVideo": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertEmoji": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "insertCount": {
        "type": "number",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEmoji": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertSnippet": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceSnippet": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertTable": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "columns": {
        "type": "number",
        "isOptional": true
      },
      "rows": {
        "type": "number",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditTable": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "command": {
        "type": "string",
        "isOptional": true
      },
      "editType": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceKeyboardEscape": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "format": "string",
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceAnchor": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "insertLocation": {
        "type": "string",
        "isOptional": true
      },
      "dragStage": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceVisualBlocks": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "active": "boolean",
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertCallout": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "type": {
        "type": "string"
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditCallout": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "editType": {
        "type": "string"
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceCharmap": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceFindReplace": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertGoogleDoc": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "useUrlInput": {
        "type": "boolean",
        "isOptional": true
      },
      "isPostBody": {
        "type": "boolean",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceAddNewGoogleAccount": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceCancelGoogleDoc": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "uiSource": {
        "type": "string",
        "isOptional": true
      },
      "errorMessage": {
        "type": "string",
        "isOptional": true
      },
      "useUrlInput": {
        "type": "boolean",
        "isOptional": true
      },
      "message": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceEditIcon": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "version": {
        "type": "string",
        "isOptional": true
      },
      "aspectChanged": {
        "type": "string",
        "isOptional": true
      },
      "position": {
        "type": "string",
        "isOptional": true
      },
      "color": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "purpose": {
        "type": "string",
        "isOptional": true
      },
      "size": {
        "type": "string",
        "isOptional": true
      },
      "title": {
        "type": "string",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "setName": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "tinymceInsertIcon": {
    "name": "Edit",
    "class": "interaction",
    "properties": {
      "action": "string",
      "inline": [
        "yes",
        "no"
      ],
      "setName": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "version": {
        "type": "string",
        "isOptional": true
      },
      "inApp": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "rich-text"
  },
  "clickedTableLink": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "dataType": "string"
    },
    "namespace": "reporting",
    "version": "1"
  },
  "toggleLegendItem": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "clickReportSpecificAction": {
    "name": "DASHBOARD_INTERACTION",
    "class": "interaction",
    "properties": {
      "type": {
        "type": "string",
        "isOptional": true
      },
      "data_type": {
        "type": "string",
        "isOptional": true
      },
      "actionType": [
        "create-task",
        "add-persona",
        "set-quotas",
        "show-goals",
        "show-offline-sources",
        "customize-sales-performance",
        "set-goals",
        "go-to-crm"
      ]
    },
    "namespace": "reporting",
    "version": "1"
  },
  "setMarketingPerformanceGoals": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "initializeMarketingPerformanceGoals": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "type": [
        "LAST_MONTHS_VALUES",
        "DEFAULT_VALUES"
      ]
    },
    "namespace": "reporting",
    "version": "1"
  },
  "setSrvGoal": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "actionType": {
        "type": [
          "add-goal",
          "remove-goal",
          "reset-goal"
        ],
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickGoToLink": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "openReportFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "selectQuickFilter": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "dataType": {
        "type": "string"
      },
      "property": {
        "type": "string"
      },
      "actionType": {
        "type": [
          "edit"
        ]
      },
      "action": {
        "type": [
          "filter"
        ]
      },
      "assetType": {
        "type": [
          "report",
          "srv-checkbox-table"
        ],
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "toggleReportChartType": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "dataType": {
        "type": "string"
      },
      "chartType": {
        "type": "string"
      },
      "actionType": {
        "type": [
          "edit"
        ]
      },
      "action": {
        "type": [
          "change chart type"
        ]
      },
      "assetType": {
        "type": [
          "report"
        ],
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "addSrvSavedFilter": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "changeSrvReportConfigFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "condition-added",
          "condition-deleted"
        ],
        "isOptional": false
      },
      "filterType": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "changeSrvObjectSpecificFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "filterType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "changeSrvDateFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "date-range",
          "date-property",
          "compared-to",
          "frequency"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "changeSrvSnowflakeFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "resetSrvFilters": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "namespace": "reporting",
    "version": "1"
  },
  "toggleSrvTabs": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "srv-filters-tab",
          "srv-about-tab"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "drillInto": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "drill-into"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report",
          "ai-generated-report"
        ],
        "isOptional": false
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "hoverOver": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "hover-over"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report"
        ],
        "isOptional": false
      },
      "chartType": {
        "type": "string",
        "isOptional": true
      },
      "dataTypes": {
        "type": "array",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": false
      },
      "templateKey": {
        "type": "string",
        "isOptional": true
      },
      "origin": {
        "type": "string",
        "isOptional": true
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "isNonPlatformReport": {
        "type": "boolean",
        "isOptional": true
      },
      "reportIdentifier": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "toggleSummaryInsight": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "show-summary",
          "hide-summary"
        ]
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "changeChartType": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "change-chart-type"
        ]
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "reportType": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "toggleDatasetInsights": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "enable",
          "disable"
        ]
      },
      "value": {
        "type": "string"
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "selectDimension": {
    "name": "REPORT_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "change-report-dimension"
        ]
      },
      "value": {
        "type": "string",
        "isOptional": true
      },
      "assetType": {
        "type": "string",
        "isOptional": true
      },
      "applicationName": {
        "type": "string",
        "isOptional": true
      },
      "whereScreen": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickTableCellLink": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "action": {
        "type": [
          "click-table-cell-link"
        ],
        "isOptional": false
      },
      "assetType": {
        "type": [
          "report"
        ],
        "isOptional": false
      },
      "reportId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardId": {
        "type": "string",
        "isOptional": true
      },
      "dashboardReportIds": {
        "type": "array",
        "isOptional": true
      },
      "objectId": {
        "type": "string",
        "isOptional": false
      },
      "linkClicked": {
        "type": "string",
        "isOptional": false
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "viewReportingInsights": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "interactionSource": {
        "type": [
          "single-object-report-viewer"
        ],
        "isOptional": false
      },
      "insightReportMetric": {
        "type": [
          "MAX",
          "AVG",
          "MIN",
          "SUM"
        ],
        "isOptional": false
      },
      "insightReportChartType": {
        "type": [
          "DATA_WELL",
          "PIE",
          "TABLE"
        ]
      },
      "originalReportMetric": {
        "type": "string",
        "isOptional": false
      },
      "originalReportChartType": {
        "type": "string",
        "isOptional": false
      },
      "insightReportIndex": {
        "type": "number"
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "clickReportingInsightsUserFeedback": {
    "name": "ANALYTICS_INTERACTION",
    "class": "interaction",
    "properties": {
      "interactionSource": {
        "type": [
          "single-object-report-viewer"
        ],
        "isOptional": false
      },
      "insightReportMetric": {
        "type": [
          "MAX",
          "AVG",
          "MIN",
          "SUM"
        ],
        "isOptional": false
      },
      "insightReportChartType": {
        "type": [
          "DATA_WELL",
          "PIE",
          "TABLE"
        ]
      },
      "originalReportMetric": {
        "type": "string",
        "isOptional": false
      },
      "originalReportChartType": {
        "type": "string",
        "isOptional": false
      },
      "userFeedback": {
        "type": [
          "positive",
          "negative"
        ]
      }
    },
    "namespace": "reporting",
    "version": "1"
  },
  "fileManagerLib": {
    "name": "File Manager Lib",
    "class": "usage",
    "properties": {
      "componentName": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerSetPanelExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "properties": {
      "panel": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerExploreFiles": {
    "name": "Explore Files",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerImageOptimization": {
    "name": "Change image optimization setting",
    "class": "interaction",
    "properties": {
      "setting": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerManageFiles": {
    "name": "Manage Files",
    "class": "interaction",
    "properties": {
      "count": {
        "type": "number",
        "isOptional": true
      },
      "fileSource": {
        "type": [
          "AI_GENERATED",
          "CANVA",
          "SHUTTERSTOCK"
        ],
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerManageFolders": {
    "name": "Manage Folders",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerBrowseShutterstock": {
    "name": "Browse Shutterstock",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerAlert": {
    "name": "Alert interaction",
    "class": "interaction",
    "namespace": "file-picker",
    "version": "v2",
    "properties": {
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    }
  },
  "fileManagerBulkImport": {
    "name": "Bulk Import Images",
    "class": "interaction",
    "properties": {
      "action": "string",
      "imageCount": {
        "type": "number",
        "isOptional": true
      },
      "isImageFile": {
        "type": "boolean",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerLibErrorDisplay": {
    "name": "Error display",
    "class": "view",
    "properties": {
      "type": "string",
      "action": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "drawerType": {
        "type": "string",
        "isOptional": true
      },
      "pickerType": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-picker",
    "version": "v2"
  },
  "fileManagerVideoOptIn": {
    "name": "video optin",
    "class": "interaction",
    "properties": {
      "hasOptedBefore": {
        "type": "boolean",
        "isOptional": true
      },
      "optInStatus": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerVideoInteraction": {
    "name": "video interaction",
    "class": "interaction",
    "properties": {
      "videoTitle": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerUpload": {
    "name": "upload file",
    "class": "interaction",
    "properties": {
      "size": {
        "type": "number",
        "isOptional": true
      },
      "errorType": {
        "type": "string",
        "isOptional": true
      },
      "statusCode": {
        "type": "number",
        "isOptional": true
      },
      "videoOptInStatus": {
        "type": "string",
        "isOptional": true
      },
      "videoDuration": {
        "type": "number",
        "isOptional": true
      },
      "videoHostingProvider": {
        "type": [
          "mux"
        ],
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerUploadDeduplication": {
    "name": "check upload duplicates",
    "class": "interaction",
    "properties": {
      "hasData": {
        "type": "boolean",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "size": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerVideoPQL": {
    "name": "Video PQL",
    "class": "interaction",
    "properties": {
      "alert": {
        "type": "string",
        "isOptional": true
      },
      "limit": {
        "type": "number",
        "isOptional": true
      },
      "quantityRemaining": {
        "type": "number",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  },
  "fileManagerImageGeneration": {
    "name": "image generation",
    "class": "interaction",
    "properties": {
      "errorCount": {
        "type": "number",
        "isOptional": true
      },
      "isFeedbackPositive": {
        "type": "boolean",
        "isOptional": true
      },
      "feedbackText": {
        "type": "string",
        "isOptional": true
      },
      "resolution": {
        "type": "string",
        "isOptional": true
      },
      "style": {
        "type": "string",
        "isOptional": true
      },
      "correlationId": {
        "type": "string",
        "isOptional": true
      },
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "action": {
        "type": "string",
        "isOptional": true
      },
      "count": {
        "type": "number",
        "isOptional": true
      },
      "duration": {
        "type": "number",
        "isOptional": true
      },
      "fileType": {
        "type": [
          "IMG",
          "MOVIE",
          "DOCUMENT",
          "AUDIO",
          "OTHER"
        ],
        "isOptional": true
      },
      "fileExtension": {
        "type": "string",
        "isOptional": true
      },
      "target": {
        "type": "string",
        "isOptional": true
      },
      "hostApp": {
        "type": "string",
        "isOptional": true
      },
      "deployableName": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "isEmbedded": {
        "type": "boolean",
        "isOptional": true
      }
    },
    "namespace": "file-manager",
    "version": "v2"
  }
};